import { useState, useEffect, useRef } from "react";
export default function QualificationCriteria() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const cards = [{
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>,
    heading: "Takes less than 1 minute",
    body: "Answer 7 simple operational questions. That's it."
  }, {
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>,
    heading: "No documents required",
    body: "No business licenses, legal reviews, or credit card inputs needed."
  }, {
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>,
    heading: "No commitment",
    body: "Cancel anytime. 3% commission on processed transactions only."
  }, {
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path></svg>,
    heading: "Instantly unlocks value",
    body: "Get a live dashboard preview and custom setup guide immediately."
  }];
  return <section style={{
    backgroundColor: "rgb(255, 255, 255)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(42, 45, 43)",
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    paddingTop: "80px",
    paddingBottom: "80px",
    animation: "none 0s ease 0s 1 normal none running"
  }}>
      <div className="page-container">
        <div ref={ref} className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="flex flex-col items-center text-center mb-12">
            <span className="mb-3 tracking-widest" style={{
            color: "#C8985C",
            fontSize: "11px",
            fontWeight: 600,
            letterSpacing: "0.15em",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            textTransform: "uppercase"
          }}>
              QUALIFICATION CRITERIA
            </span>

            <h2 style={{
            color: "rgb(31, 58, 46)",
            fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
            fontSize: "36px",
            fontWeight: "400",
            lineHeight: "40px",
            border: "0px solid oklch(0.69 0.04 165 / 0.25)",
            textAlign: "center",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "16px"
          }}>
              Not a Full Application —{" "}
              <span style={{
              color: "#C8985C",
              fontStyle: "italic"
            }}>
                Just a Quick
                <br />
                Qualification
              </span>
            </h2>

            <p style={{
            color: "rgba(42, 45, 43, 0.7)",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "24px",
            border: "0px solid oklch(0.69 0.04 165 / 0.25)",
            textAlign: "center",
            animation: "none 0s ease 0s 1 normal none running",
            maxWidth: "540px"
          }}>
              We've stripped away the corporate bloat. Here is what soft-enrollment actually means for your spa.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {cards.map((card, i) => <div key={i} className={`transition-all duration-700 hover:shadow-xl`} style={{
            backgroundColor: "rgb(247, 246, 241)",
            border: "1px solid oklch(0.69 0.04 165 / 0.25)",
            borderRadius: "10px",
            padding: "32px",
            transitionDelay: `${i * 100}ms`,
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(16px)",
            transition: `opacity 0.7s ease ${i * 100}ms, transform 0.7s ease ${i * 100}ms, box-shadow 0.3s ease`
          }}>
                <div style={{
              width: "44px",
              height: "44px",
              backgroundColor: "rgb(237, 235, 228)",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "16px",
              color: "rgb(31, 58, 46)",
              flexShrink: 0
            }}>
                  {card.icon}
                </div>

                <h3 style={{
              color: "rgb(31, 58, 46)",
              fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
              fontSize: "18px",
              fontWeight: "600",
              lineHeight: "28px",
              border: "0px solid oklch(0.69 0.04 165 / 0.25)",
              animation: "none 0s ease 0s 1 normal none running",
              marginBottom: "8px"
            }}>
                  {card.heading}
                </h3>

                <p style={{
              color: "rgba(42, 45, 43, 0.7)",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "22.75px",
              border: "0px solid oklch(0.69 0.04 165 / 0.25)",
              animation: "none 0s ease 0s 1 normal none running",
              margin: 0
            }}>
                  {card.body}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}